import React, { Component } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

import { colors } from './common';

export const Chart = ({ stats, xKeys }) => (
  <div style={{ margin: '30px 0' }}>
    <BarChart width={760} height={200} data={stats}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="tag" />
      <YAxis />
      <Tooltip />
      <Legend />
      {
        xKeys.map((xKey, i) => (
          <Bar 
            key={i}
            type="monotone"
            fill={colors[i]}
            dataKey={xKey}
            activeDot={{ r: 8 }}
            label={{ fill: 'black', fontSize: 16 }} />
          ))
      }
    </BarChart>
  </div>
);